/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-01-12 13:49:58
 * @LastEditors: K
 * @LastEditTime: 2022-06-16 15:37:57
 */
import { Settinglable } from '../models/setting'
import { TenentSettinglable } from '../models/tenantSetting'
import { API_PREFIX } from './constant'
import { Request } from './request'

export interface TenentSettingParams {
  tenant: TenentSettinglable
  functionList: Settinglable[]
}
export function getTenentSettingSave(body: TenentSettingParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/save`,
    method: 'POST',
    body,
  }
}

export interface TenentSettingParmas {
  tenantId: string
}

export function getSettingDetail(params: TenentSettingParmas): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/detail`,
    method: 'POST',
    params,
  }
}

export interface MedicalSettingParams {
  cityHospitalNb: string
  countryHospitalNb: string
  endTime: string
  id: number
  insuranceCode: string
  insuranceName: string
  startTime: string
  status: number
  tenantId: number
  ybIp: string
  ybMac: string
  yidiHospitalNb: string
  isFaceCall: number
  ybFaceRecognition: number
}

export interface MedicalItemParams {
  id: number
  tenantId: string
}

export function getMedicalSettingList(tenantId: number): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/list`,
    method: 'GET',
    params: {
      tenantId,
    },
  }
}

export function editMedicalSetting(body: MedicalSettingParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/submit`,
    method: 'POST',
    body,
  }
}

export function getSystemList(status?: number): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/syslist`,
    method: 'GET',
    params: {
      status,
    },
  }
}

export function getMedicalItem(params: MedicalItemParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/detail`,
    method: 'GET',
    params,
  }
}

// 获取电子发票授权地址
export interface InvoiceUrlParams {
  supplierId?: number
  tenantId: string
  id?: number
}
export function invoiceUrl(body: InvoiceUrlParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dzfp/getUrl`,
    method: 'POST',
    body,
  }
}

// 获取电子发票供应商
export function invoiceSupplierList(): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/sysdzfpsupplierconfig/getlist`,
    method: 'GET',
  }
}

// 回显。获取开电子发票通列表
export function invoiceDetail(body:InvoiceUrlParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dzfpconfig/getlist`,
    method: 'POST',
    body
  }
}

// 新建，修改电子发票授权机构
export interface EditInvoiceParams{
  accessToken:string ,
  id: number,
  status: number,
  supplierId: number,
  supplierName: string,
  taxNo: string,
  tenantId: number
}
// 米雅聚合支付结构体
export interface savePayParams{
  openHubPay:number ,
  chlMiyaVO: {
    tenantName: string,
    male: string,
    key: string,
    merchantNo: number,
    marketNo: number,
    tenantId: number,
  }
}

// 银联聚合支付结构体
export interface savePayParamsYinlian{
  openHubPayYinlian:number ,
  chlYinlianVO: {
    tenantName: string,
    male: string,
    merchantCode: string,
    terminalCode: string,
    tenantId: number,
  }
}

// 康邻聚合支付结构体
export interface savePayParamsKanglin{
  openHubPayKanglin:number ,
  chlKanglinVO: {
    mode: string,
    TermCode: string,
    tenantName: string,
    appcode: string,
    key: string,
    tenantId: number,
  }
}
export function editInvoice(body:EditInvoiceParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dzfpconfig/saveOrUpdate`,
    method: 'POST',
    body
  }
}

// 查询聚合支付(米雅)
export function getPayList(tenantId: string): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/payDetail`,
    method: 'GET',
    params: {
      tenantId,
    },
  }
}
// 查询聚合支付(银联)
export function getPayListYinlian(tenantId: string): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/payDetailYinlian`,
    method: 'GET',
    params: {
      tenantId,
    },
  }
}
// 查询聚合支付(康邻)
export function getPayListKanglin(tenantId: string): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/payDetailKanglin`,
    method: 'GET',
    params: {
      tenantId,
    },
  }
}
// 保存聚合支付（米雅）
export function savePayList(body:savePayParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/aggregatePaySave`,
    method: 'POST',
    body
  }
}
// 保存聚合支付（银联）
export function savePayListYinlian(body:savePayParamsYinlian): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/aggregatePaySaveYinlian`,
    method: 'POST',
    body
  }
}
// 保存聚合支付（康邻）
export function savePayListKanglin(body:savePayParamsKanglin): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/function/aggregatePaySaveKanglin`,
    method: 'POST',
    body
  }
}
